import { render, staticRenderFns } from "./CmgRewardsExtras.vue?vue&type=template&id=d15c8646&scoped=true&lang=pug"
import script from "./cmg-rewards-extras.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-extras.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsExtras.vue?vue&type=style&index=0&id=d15c8646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15c8646",
  null
  
)

export default component.exports